module.exports = __webpack_public_path__ + "media/post-listing-block-2-overlay@2x.2c5f07d2.webp";